import React, { useState } from 'react';
import { Search } from 'lucide-react';

// Lista pesquisável de funções sugeridas (opcional); funciona bem no telemóvel.
export const SuggestionPicker = ({ suggestions, picked, onPick, t }) => {
  const [q, setQ] = useState('');
  // Sem acentos, grafia PT/BR (recepção = receção, projecto = projeto) e radical das palavras (receção ≈ rececionista)
  const norm = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/p(?=c|t)|c(?=t)/g, '');
  const stems = norm(q.trim()).split(/\s+/).filter(Boolean).map((w) => (w.length > 5 ? w.slice(0, w.length - 2) : w));
  const list = suggestions.map((s, i) => ({ s, i })).filter(({ s }) => stems.every((w) => norm(s.title_pt).includes(w)));
  return (
    <div>
      {suggestions.length > 8 && (
        <div className="relative mb-3">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('createJob.suggestionSearch')}
            className="w-full h-10 pl-9 pr-3 rounded-md border border-gray-300 bg-white text-base sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            data-testid="suggestion-search-input" />
        </div>
      )}
      <div className="grid grid-cols-1 min-[400px]:grid-cols-2 md:grid-cols-3 gap-2 max-h-72 overflow-y-auto pr-1" data-testid="suggestion-list">
        {list.map(({ s, i }) => (
          <button key={i} type="button" onClick={() => onPick(s)}
            className={`text-left px-3 py-2.5 rounded-md border text-sm font-medium transition-colors ${
              picked === s.title_pt ? 'bg-blue-600 text-white border-blue-600 shadow-md' : 'bg-white text-gray-800 border-gray-200 hover:border-blue-400 hover:bg-blue-50'}`}
            data-testid={`suggestion-${i}`}>
            {s.title_pt}
          </button>
        ))}
      </div>
      {list.length === 0 && <p className="text-sm text-gray-500 italic" data-testid="suggestion-no-match">{t('createJob.suggestionNoMatch')}</p>}
    </div>
  );
};
